var _rect, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 3.5,
    fill: "white",
    stroke: "#ACB5BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2 22.8L28.7 27.3C29.1 27.7 29.1 28.3 28.7 28.7C28.5 28.9 28.2 29 28 29C27.8 29 27.5 28.9 27.3 28.7L22.8 24.2C21.3 25.3 19.5 26 17.5 26C12.8 26 9 22.2 9 17.5C9 12.8 12.8 9 17.5 9C22.2 9 26 12.8 26 17.5C26 19.5 25.3 21.4 24.2 22.8ZM17.5 11C13.9 11 11 13.9 11 17.5C11 21.1 13.9 24 17.5 24C19.3 24 20.9 23.3 22.1 22.1C23.3 20.9 24 19.3 24 17.5C24 13.9 21.1 11 17.5 11Z",
    fill: "#212529"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2879_21206",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2 22.8L28.7 27.3C29.1 27.7 29.1 28.3 28.7 28.7C28.5 28.9 28.2 29 28 29C27.8 29 27.5 28.9 27.3 28.7L22.8 24.2C21.3 25.3 19.5 26 17.5 26C12.8 26 9 22.2 9 17.5C9 12.8 12.8 9 17.5 9C22.2 9 26 12.8 26 17.5C26 19.5 25.3 21.4 24.2 22.8ZM17.5 11C13.9 11 11 13.9 11 17.5C11 21.1 13.9 24 17.5 24C19.3 24 20.9 23.3 22.1 22.1C23.3 20.9 24 19.3 24 17.5C24 13.9 21.1 11 17.5 11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2879_21206)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7H31V31H7V7Z",
    fill: "#828282"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.13c90a17b9bf97ceb7cf885db43df88c.svg";
export { ForwardRef as ReactComponent };